import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken, getVerification } from '@/utils/auth'
import { SERVER_URL } from '@/config'
import vm from '@/main'

// create an axios instance
const service = axios.create({
    baseURL: SERVER_URL, // api 的 base_url
    withCredentials: false, // 跨域请求时发送 cookies
    timeout: 15000, // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        const token = getToken()
        // const verificationName = getVerification();
        // Do something before request is sent
        if (store.getters.token) {
            // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
            // config.headers['X-Token'] = getToken()
            config.headers['Authorization'] = token
        } else {
            config.headers['Authorization'] = undefined
        }
        // if (verificationName) {
        //   config.headers['Verification'] = verificationName;
        // }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        console.error('请求发送错误!!!', error)
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get information such as headers or status
     * Please return  response => response
     */
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
        const res = response.data
        // if (res.code !== 20000) {
        //   Message({
        //     message: res.message,
        //     type: 'error',
        //     duration: 5 * 1000
        //   })
        //   // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
        //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        //     // 请自行在引入 MessageBox
        //     // import { Message, MessageBox } from 'element-ui'
        //     MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        //       confirmButtonText: '重新登录',
        //       cancelButtonText: '取消',
        //       type: 'warning'
        //     }).then(() => {
        //       store.dispatch('user/resetToken').then(() => {
        //         location.reload() // 为了重新实例化vue-router对象 避免bug
        //       })
        //     })
        //   }
        //   return Promise.reject('error')
        // } else {
        //   return res
        // }
        /*if (res.status === 40101) { // token过期
        Message.error('token to exceed the time limit')
        store.dispatch('user/logout')
      }*/
        return response
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000,
        })
        return Promise.reject(error)
    }
)


/* 
	重新封装请求方法
	适用于2020.9.11及之后新增API规范
*/
function request(option) {
    const { url = '', method = 'get', toastError, data } = option
    let config = {
        url,
        method,
       data,
    }
    if (data) {
        let dataKey = method && String(method).toLowerCase() == 'post' ? 'data' : 'params'
        config[dataKey] = { ...data }
        // config[dataKey]['language'] = { CHS: 'zh', EN: 'en' }[store.getters.lang]
    }

    return new Promise((resolve, reject) => {
        service(config)
            .then(response => {
                const data = response.data
                if (!data || (data && data.code != 200)) {
                    // if (toastError !== false) {
                    //     vm.$showMessage('error', data.code)
                    // }
                    reject(response.data)
                    return
                }
                resolve(response.data)
            })
            .catch(error => {
                /* 
				TODO: 
				axios的service拦截器中增加了通用错误处理，为了兼容之前的逻辑，暂时关闭此处toastError逻辑，待后续改造
			*/
                // if(toastError !== false){
                // 	Message.error(vm.$t('Page.NetworkFault'))
                // }
                reject({ code: 0, data: error })
            })
    })
}

export default service
export { request }
